import { FileUnknownOutlined } from '@ant-design/icons'
import { Layout, Menu } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import Sider from 'antd/lib/layout/Sider'
import React, { useState } from 'react'
import { getDocumentByName, getDocumentItems } from './util'
const { SubMenu } = Menu
export const TemplateMacroDocument = (props) => {
  const [document, setDocument] = useState<string>()
  const getMenuItems = () => {
    var dic = getDocumentItems()
    return Object.keys(dic).map((key) => {
      const value = dic[key]
      const item = (
        <SubMenu key={key} icon={<FileUnknownOutlined />} title={key}>
          {value.map((x) => (
            <Menu.Item
              key={`${x.groupName}.${x.name}`}
              onClick={() => {
                const doc = getDocumentByName(x.name!)
                setDocument(doc)
              }}
            >
              {x.name}({x.desc})
            </Menu.Item>
          ))}
        </SubMenu>
      )
      return item
    })
  }

  return (
    <Layout
      hasSider
      style={{
        height: 500,
        minHeight: 500,
        width: '100%',
        border: '1px solid #d9d9d9'
      }}
    >
      <Sider
        width={250}
        style={{
          overflow: 'auto',
          height: '100%',
          backgroundColor: '#FFF'
        }}
      >
        <Menu mode='inline'>{getMenuItems()}</Menu>
      </Sider>

      <Layout
        style={{
          height: '100%',
          minHeight: '100%'
        }}
      >
        <Content
          style={{
            overflow: 'initial',
            padding: '5px 10px',
            background: '#FFF'
          }}
        >
          <textarea
            readOnly
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              background: '#FFF',
              outline: 'none',
              resize: 'none'
            }}
            value={document}
          />
        </Content>
      </Layout>
    </Layout>
  )
}
